// src/lib/policy.ts
export const POLICY_VERSION = "v1.0"; // העלה כשיש שינוי מהותי

const LS_KEY = `lf_pp_${POLICY_VERSION}`;

export function hasLocalConsent(): boolean {
  try { return localStorage.getItem(LS_KEY) === "1"; } catch { return false; }
}

export function setLocalConsent() {
  try { localStorage.setItem(LS_KEY, "1"); } catch {}
}

// בדיקת דגל ב-DB למשתמש המחובר
export async function hasDbConsent(supabase: any): Promise<boolean> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return false;
  const { data, error } = await supabase
    .from('privacy_consents')
    .select('id')
    .eq('user_id', user.id)
    .eq('policy_version', POLICY_VERSION)
    .maybeSingle();
  if (error) throw error;
  return !!data;
}

export async function upsertConsentToDb(supabase: any) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return;

  const { data: exists, error: selErr } = await supabase
    .from('privacy_consents')
    .select('id')
    .eq('user_id', user.id)
    .eq('policy_version', POLICY_VERSION)
    .maybeSingle();
  if (selErr) throw selErr;
  if (exists) return;

  const user_agent = typeof navigator !== "undefined" ? navigator.userAgent : null;
  const { error: insErr } = await supabase.from('privacy_consents').insert({
    user_id: user.id,
    policy_version: POLICY_VERSION,
    user_agent
  });
  if (insErr) throw insErr;
}
